import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ModalUtils from 'utils/ModalUtils';

// GraphQL
import GraphQLClient from 'services/apollo/GraphQLClient';
import DealsQuery from 'services/graphQL/query/DealsQuery';

const CommissionsDialogContainer = (WrappedComponent) => class extends Component {
    static propTypes = {
        applyAmountFinancedValue: PropTypes.func.isRequired,
        portfolioId: PropTypes.number.isRequired,
        contractId: PropTypes.number.isRequired,
        docStamp: PropTypes.number.isRequired,
        waiveDocStamp: PropTypes.bool.isRequired,
        docStampOverride: PropTypes.bool.isRequired,
    };

    constructor(props) {
        super(props);
        this.graphqlClient = new GraphQLClient();

        this.state = {
            portfolioList: [],
            contractList: [],
            portfolioId: 0,
            contractId: 0,
            docStamp: 0,
            waiveDocStamp: false,
            docStampOverride: false,
        };

        this.initBind();
    }

    componentDidMount() {
        const {
            props: {
                portfolioId, contractId, docStamp, waiveDocStamp, docStampOverride,
            },
        } = this;

        this.setState({
            portfolioId,
            contractId,
            docStamp,
            waiveDocStamp,
            docStampOverride,
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const updates = {};
        const { state } = this;
        const {
            docStamp,
            waiveDocStamp,
            docStampOverride,
        } = state;

        if (nextProps.docStamp !== docStamp) {
            updates.docStamp = nextProps.docStamp;
        }
        if (nextProps.waiveDocStamp !== waiveDocStamp) {
            updates.waiveDocStamp = nextProps.waiveDocStamp;
        }
        if (nextProps.docStampOverride !== docStampOverride) {
            updates.docStampOverride = nextProps.docStampOverride;
        }

        if (Object.keys(updates).length > 0) {
            this.setState(updates);
        }
    }

    onChange(name, value) {
        this.setState({
            [name]: value === '' || value === undefined ? null : value,
        });
    }

    onChangeWaiveDocStamp(value) {
        this.setState((prevState) => ({
            waiveDocStamp: value,
            docStamp: value ? 0 : prevState.docStamp,
        }), () => {
            if (!value) {
                const { state, props } = this;
                const {
                    portfolioId, contractId, waiveDocStamp, docStampOverride, docStamp,
                } = state;
                props.applyAmountFinancedValue(portfolioId, contractId, waiveDocStamp, docStampOverride, docStamp);
            }
        });
    }

    onChangeDocStampOverride(value) {
        this.setState(() => ({
            docStampOverride: value,
        }), () => {
            if (!value) {
                const { state, props } = this;
                const {
                    portfolioId, contractId, waiveDocStamp, docStampOverride, docStamp,
                } = state;
                props.applyAmountFinancedValue(portfolioId, contractId, waiveDocStamp, docStampOverride, docStamp);
            }
        });
    }

    onSave() {
        const {
            props, state: {
                contractId, portfolioId, waiveDocStamp, docStampOverride, docStamp,
            },
        } = this;

        props.applyAmountFinancedValue(portfolioId, contractId, waiveDocStamp, docStampOverride, docStamp);
    }

    setDefaultContract() {
        const { state: { contractId, contractList } } = this;

        if (contractId === null) {
            const contract = contractList.find((item) => item.isDefault);

            if (contract) {
                this.setState({ contractId: contract.loanContractTemplateId });
            }
        }
    }

    fetchPortfolios() {
        this.graphqlClient
            .query(DealsQuery.GET_PORTFOLIOS)
            .then((response) => {
                const { data, graphQLErrors } = response;

                if (graphQLErrors) {
                    ModalUtils.errorMessage(graphQLErrors);
                    return;
                }

                if (data?.listPortfolios) {
                    this.setState({
                        portfolioList: data.listPortfolios,
                    });
                }
            });
    }

    fetchContracts() {
        this.graphqlClient
            .query(DealsQuery.GET_CONTRACTS)
            .then((response) => {
                const { data, graphQLErrors } = response;

                if (graphQLErrors) {
                    ModalUtils.errorMessage(graphQLErrors);
                    return;
                }

                if (data?.getLoanContractTemplateList) {
                    this.setState({
                        contractList: data.getLoanContractTemplateList,
                    }, () => this.setDefaultContract());
                }
            });
    }

    initBind() {
        this.onSave = this.onSave.bind(this);
        this.fetchPortfolios = this.fetchPortfolios.bind(this);
        this.fetchContracts = this.fetchContracts.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onChangeWaiveDocStamp = this.onChangeWaiveDocStamp.bind(this);
        this.onChangeDocStampOverride = this.onChangeDocStampOverride.bind(this);
    }

    render() {
        const { props, state } = this;

        return (
            <WrappedComponent
                {...props}
                {...state}
                onSave={this.onSave}
                fetchContracts={this.fetchContracts}
                fetchPortfolios={this.fetchPortfolios}
                onChange={this.onChange}
                onChangeWaiveDocStamp={this.onChangeWaiveDocStamp}
                onChangeDocStampOverride={this.onChangeDocStampOverride}
            />
        );
    }
};

export default CommissionsDialogContainer;
